export const activityTypes = [
  'raids',
  'dungeons',
  'meeting',
  'arena',
  'battlegrounds',
  'custom',
] as const

type ActivityType = typeof activityTypes[number]
export default ActivityType
